<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full xl:w-1/2 mb-base">
                <div class="vx-card">
                    <div class="vx-card__header">
                        <div class="vx-card__title">
                            <h4 class="mb-4">My transactions</h4>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col mb-base">
                            <vs-input id="search-box" v-on:input="filterChanged" icon="search" size="large"
                                      v-model="searchInput"
                                      label-placeholder="Search"
                                      class="ml-6 mt-6"/>
                        </div>
                        <div class="vx-col mb-base grid-filter-icon-wrapper" v-on:click="showFilters = !showFilters">
                            <feather-icon icon="FilterIcon" svgClasses="w-6 h-6 mt-6"/>
                        </div>
                    </div>
                    <div class="vx-row ag-grid-columns-filter-wrapper" v-bind:class="{ show: showFilters}">
                        <div class="vx-col ml-6">
                            <span v-for="(column, index) in columnsFilter" v-bind:key="index"
                                  class="filter-checkbox-wrapper mb-2">
                                <vs-checkbox v-model="column.show"
                                             @change="setColumnsVisibility()">{{column.name}}</vs-checkbox>
                            </span>
                        </div>
                    </div>
                    <ag-grid-vue
                        class="ag-theme-material w-100 my-4 ag-grid-table"
                        :columnDefs="transactionsListColumns"
                        :rowData="transactionsData"
                        :defaultColDef="defaultColDef"
                        :gridOptions="gridOptions"
                        :components="transactionComponents"
                        rowSelection="multiple"
                        colResizeDefault="shift"
                        :animateRows="true"
                        :pagination="true"
                        :paginationPageSize="paginationPageSize"
                        :suppressPaginationPanel="true"
                        overlayNoRowsTemplate=" "
                        v-on:gridReady="setGridSize($event)">
                    </ag-grid-vue>

                    <vs-pagination
                        :total="totalPages"
                        :max="paginationMaxSize"
                        v-model="currentPage"/>
                </div>
            </div>
            <div class="vx-col w-full xl:w-1/2 mb-base">
                <div class="vx-card mb-base">
                    <div class="vx-card__header">
                        <div class="vx-card__title">
                            <h4>Balance progress</h4>
                        </div>
                    </div>
                    <statistics-card-line
                        :iconRight="true" icon="DollarSignIcon"
                        :statistic="balance + ' ' + currency" statisticTitle="Balance"
                        :chartData="balanceProgress" color="success" type="area"/>
                </div>

                <!-- apparently it has no sense, plus it doesn't work properly
                <div class="vx-card mb-base" v-if="referrersProfitabilityInfo.series.length !== 0">
                    <div class="vx-card__header">
                        <div class="vx-card__title">
                            <h4>Profitability of Referrers</h4>
                        </div>
                    </div>
                    <vue-apex-charts
                            type="donut" height="340" class="mb-12 mt-4"
                            :options="chartOptions"
                            :series="referrersProfitabilityInfo.series" ></vue-apex-charts>

                    <ul class="referrersInfoWrapper">
                        <li v-for="referrerData in referrersProfitabilityInfo.analyticsData" :key="referrerData.referrer_id" class="flex mb-3">
                            <feather-icon :icon="referrerData.icon" :svgClasses="[`h-5 w-5 stroke-current text-${referrerData.color}`]"></feather-icon>
                            <span class="ml-2 inline-block font-semibold">Referrer id: {{ referrerData.referrer_id }}</span>
                            <span class="mx-2">-</span>
                            <span class="mr-4">{{ referrerData.relativeProfitability }}%</span>
                        </li>
                    </ul>
                </div>
                -->
            </div>
        </div>
    </div>
</template>

<script>

    import RestService from '../services/RestService';

    import VueApexCharts from 'vue-apexcharts'
    import {AgGridVue} from 'ag-grid-vue';
    import '../assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import StatisticsCardLine from '../components/statistics-cards/StatisticsCardLine';

    import CellRendererValue from './cell-renderer/CellRendererValue'
    import CellRendererDate from './cell-renderer/CellRendererDate'
    import CellRendererDescription from './cell-renderer/CellRendererDescription'
    import CellRendererPending from './cell-renderer/CellRendererPending'

    export default {

        name: "transactions-view",
        components: {
            VueApexCharts,
            AgGridVue,
            StatisticsCardLine,

            CellRendererValue,
            CellRendererDate,
            CellRendererDescription,
            CellRendererPending
        },
        methods: {
            getBalanceValues() {
                let transactions = this.listOfTransactions.slice();
                transactions.reverse();
                transactions = transactions.filter(t => !t.purpose.purpose.includes('membership'));
                let current = 0;
                return transactions.map(t => {
                    current += t.value;
                    return current;
                });
            },
            /* belonging to commented graph
            getReferrersProfitability() {
                let referrersTransactions = [];
                this.listOfTransactions.forEach(t => {
                    if (referrersTransactions.filter(r => r.Payer_id === t.Payer_id).length === 0) {
                        referrersTransactions.push({Payer_id: t.Payer_id, transactions: [t.value]});
                    } else {
                        referrersTransactions = referrersTransactions.map(r => {
                            if (r.Payer_id === t.Payer_id) {
                                r.transactions.push(t.value);
                            }
                            return r;
                        })
                    }
                });
                referrersTransactions = referrersTransactions.map((r, index) => {
                   r.transactionsSum = r.transactions.reduce((a, b) => a + b, 0);
                   this.referrersProfitabilityInfo.series.push(r.transactionsSum);
                   this.chartOptions.labels.push(r.Payer_id);
                    this.referrersProfitabilityInfo.analyticsData.push({
                        referrer_id: r.Payer_id,
                        icon: 'UserIcon',
                        color: this.chartOptions.colors[index],
                        // TODO change if balance doesn't equal sum of all transactions as in beforeMount() todo comment
                        relativeProfitability: Math.round(((r.transactionsSum / this.balance * 100) + Number.EPSILON) * 100) / 100
                    });
                   return r;
                });
                return referrersTransactions;
            },
            */
            setGridSize(params) {
                if ((window.innerWidth > 768 && window.innerWidth < 1200) || window.innerWidth > 2000)
                    params.api.sizeColumnsToFit();
                this.gridOptions.api.setDomLayout('autoHeight');
            },

            filterChanged() {
                this.gridApi.setQuickFilter(document.getElementById('search-box').value);
            },

            setColumnsVisibility() {
                this.columnsFilter.forEach(c => {
                    this.gridOptions.columnApi.setColumnVisible(c.id, c.show);
                });
                // TODO this needs optimization
                if ((window.innerWidth > 768 && window.innerWidth < 1200) || window.innerWidth > 2000)
                    this.gridApi.sizeColumnsToFit();
            }
        },
        async beforeMount() {

            const responseTransactions = await RestService.getTransactions();
            if (responseTransactions.success)
                this.listOfTransactions = responseTransactions.data;

            /* TODO can balance and sum of transaction be different? */
            const balanceResponse = await RestService.getUserBalance();
            if (balanceResponse.success)
                this.balance = balanceResponse.data.balance;

            if (this.listOfTransactions) {
                this.balanceProgress = [
                    {
                        name: 'Transactions',
                        data: this.getBalanceValues()
                    }
                ];
                // functionality is commented
                //this.getReferrersProfitability();
            }
        },
        computed: {
            transactionsData() {
                return this.listOfTransactions;
            },
            paginationPageSize() {
                return 10; // TODO maybe change
            },
            paginationMaxSize() {
                if (this.gridApi) {
                    let pagesNr = this.gridApi.paginationGetTotalPages();
                    return pagesNr < 8 ? pagesNr + 1 : 7; // TODO maybe change this
                } else
                    return 1;
            },
            totalPages() {
                if (this.gridApi)
                    return this.gridApi.paginationGetTotalPages();
                else
                    return 0;
            },
            currentPage: {
                get() {
                    if (this.gridApi)
                        return this.gridApi.paginationGetCurrentPage() + 1;
                    else
                        return 1;
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1);
                }
            },
            currency() {
                return this.$store.state.currency;
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.columnsFilter = this.transactionsListColumns.map(c => {
                return {id: c.field, name: c.headerName, show: true};
            });
        },
        data() {
            return {
                gridOptions: {},
                gridApi: null,
                transactionsListColumns: [
                    {
                        headerName: 'Created at',
                        field: 'created_at',
                        cellRendererFramework: 'CellRendererDate',
                        width: 300
                    },
                    {
                        headerName: 'Value',
                        field: 'value',
                        cellRendererFramework: 'CellRendererValue',
                        width: 120
                    },
                    {
                        headerName: 'Description',
                        field: 'description',
                        cellRendererFramework: 'CellRendererDescription',
                        width: 400
                    },
                    {
                        headerName: 'Pending',
                        field: 'pending',
                        cellRendererFramework: 'CellRendererPending',
                        width: 160
                    }
                ],
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                listOfTransactions: null, // TODO general issue. Should default values for list rows be null or [] (appearance of list before API response depends on it)
                transactionComponents: {
                    CellRendererValue,
                    CellRendererDate
                },
                columnsFilter: [],
                showFilters: false,
                balanceProgress: [],
                balance: 0,
                searchInput: '',
                /* functionality commented
                chartOptions: {
                    labels: [],
                    dataLabels: {
                        enabled: false
                    },
                    legend: { show: false },
                    chart: {
                        offsetY: 30,
                        type: 'donut',
                        toolbar: {
                            show: false
                        }
                    },
                    stroke: { width: 0 },
                    colors: ['#7961F9', '#FF9F43', '#EA5455', '#28C76F', '#b8c2cc', '#1E1E1E', ],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            gradientToColors: ['#9c8cfc', '#FFC085', '#f29292', '#2ff38e', '#515151', '#dbe5ef', '#515151']
                        }
                    }
                },
                */
                /* functionality commented
                referrersProfitabilityInfo: {
                    analyticsData: [],
                    series: []
                }
                */
            }
        }
    }
</script>

<style scoped>
    @media (min-width: 2000px) {
        .xxl-w-1-2 {
            width: 50% !important;
        }
    }

    .referrersInfoWrapper {
        margin: 10px;
        padding: 10px;
    }
</style>
